module.exports = __webpack_public_path__ + "assets/img/17_1427_big.2a389271.jpg";